import { loginTypes, loginTypesForApi } from 'config/loginTypes';
import tokenManager from 'client/utils/tokenManager';
import { retrieveLineConfig } from 'utils/manipulatePartnerSponsor';
import { generateApiErrObj } from 'client/hooks/useClientErrorHandler';

export default async function loginUser(loginMethod, { partner, sponsor }) {
    // 需要先 init login type 以使用對應的方法 get token
    initTokenLoginType(loginMethod, { partner, sponsor });

    let { token: accessToken, errorResp } = await tokenManager.getAccessToken();

    // 如果沒有 access_token 並且是不登入活動，嘗試 init login token 後再重新取得 access token
    if (loginMethod === loginTypes.ANONYMOUSLOGIN) {
        if (errorResp) {
            await tokenManager.generateLoginToken();
            ({ token: accessToken, errorResp } = await tokenManager.getAccessToken());
            if (errorResp) {
                throw generateApiErrObj(errorResp);
            }
        }
    }

    const isLogin = Boolean(accessToken);
    return isLogin;
}

function initTokenLoginType(loginMethod, { partner, sponsor }) {
    const loginCredential = retrieveCredentialByLoginType({
        loginType: loginMethod,
        partner,
        sponsor
    });
    tokenManager.init(loginCredential);
}

function retrieveCredentialByLoginType({ loginType, partner, sponsor }) {
    switch (loginType) {
        case loginTypes.ANONYMOUSLOGIN:
            return { login_type: loginTypesForApi.ANONYMOUS };
        case loginTypes.FACEBOOKLOGIN:
            return {
                login_type: loginTypesForApi.FACEBOOK,
                app_id: sponsor.facebookLoginAppId || partner.facebookLoginAppId
            };
        case loginTypes.LINELOGIN:
            return {
                login_type: loginTypesForApi.LINE,
                app_id: retrieveLineConfig({ partner, sponsor }).lineLoginAppId
            };
        case loginTypes.ENTERPRISELOGIN:
        case loginTypes.DEPRECATED_CODE_VALIDATION_LOGIN:
            const app_id =
                partner['91appLoginAppId'] ||
                sponsor.enterpriseLoginAppId ||
                sponsor.enterpriseLiteLoginAppId ||
                sponsor.enterpriseCodeValidationLoginAppId ||
                partner.enterpriseLoginAppId ||
                partner.enterpriseLiteLoginAppId ||
                partner.enterpriseCodeValidationLoginAppId;
            return { login_type: loginTypesForApi.ENTERPRISE, app_id };
        case loginTypes.INSTAGRAM:
            return { login_type: loginTypesForApi.INSTAGRAM };
        default:
            return {};
    }
}
